// AUTO-GENERATED by scripts/generate-widget-registry.sh — DO NOT EDIT

import { definition as companyEarningsDef } from './items/data-provider/COMPANY_EARNINGS';
import { definition as companyProfileDef } from './items/data-provider/COMPANY_PROFILE';
import { definition as consensusTableDef } from './items/data-provider/CONSENSUS_TABLE';
import { definition as correlationDef } from './items/data-provider/CORRELATION';
import { definition as positionRiskDef } from './items/data-provider/POSITION_RISK';
import { definition as priceDef } from './items/data-provider/PRICE';
import { definition as convictionDef } from './items/input/conviction';
import { definition as qaDef } from './items/input/qa';
import { definition as scorecardDef } from './items/input/scorecard';
import { definition as tradingScoreDef } from './items/input/trading_score';
import { definition as onedriveDef } from './items/microsoft/onedrive';
import { definition as outlookDef } from './items/microsoft/outlook';
import { definition as dashboardReferenceDef } from './items/reference/dashboard_reference';
import { definition as imageRepositoryDef } from './items/repository/image_repository';
import { definition as notesRepositoryDef } from './items/repository/notes_repository';
import { definition as pdfRepositoryDef } from './items/repository/pdf_repository';

// All widget definitions (sorted by file path)
export const definitions = [
  companyEarningsDef,
  companyProfileDef,
  consensusTableDef,
  correlationDef,
  positionRiskDef,
  priceDef,
  convictionDef,
  qaDef,
  scorecardDef,
  tradingScoreDef,
  onedriveDef,
  outlookDef,
  dashboardReferenceDef,
  imageRepositoryDef,
  notesRepositoryDef,
  pdfRepositoryDef,
];
